import { useMutation } from '@apollo/client';
import { Mutations } from 'apollo';
import useAuthContext from 'hooks/useAuthContext';

const useAddPlaidError = () => {
  const context = useAuthContext('payroll_employee:edit');
  const [addPlaidError] = useMutation(Mutations.addPlaidError, { context });

  const mutation = (error, metadata) => {
    return addPlaidError({
      variables: {
        input: {
          error: (error && JSON.stringify(error)) || '{}',
          institution: JSON.stringify(metadata.institution),
          linkSessionId: metadata.link_session_id,
          requestId: metadata.request_id,
          status: metadata.status,
        },
      },
    }).then(response => ((response || {}).data || {}).addPlaidError || false);
  };

  return mutation;
};

export default useAddPlaidError;
